// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
// import "swiper/css";
import "swiper/css/free-mode";

// import required modules
import { FreeMode } from "swiper/modules";

import "../styles/YouMayAlsoLikeSlider.css";

export default function YouMayAlsoLikeSlider({ products }) {
  return (
    <div className="you-may-also-like-swiper-wrapper-container">
      <Swiper
        slidesPerView={1.5} // 1 full and 0.5 next tile visible
        spaceBetween={15}
        freeMode={true}
        modules={[FreeMode]}
        className="youMayLikeSwiper"
      >
        {products.map((product, index) => (
          <SwiperSlide key={product.product_id} className="product-slide">
            <a href={`/shop/${product.product_id}`} className="product-link">
              <div className="product-tile">
                <img
                  src={`/${product.images[0]}`}
                  alt={product.name}
                  className="product-image"
                />
                <div className="product-information">
                  <p className="product-name">{product.name}</p>
                  <p className="product-price">£{product.price}</p>
                </div>
              </div>
            </a>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
